import React from 'react';
import { useSelector } from 'react-redux';

import Link from '../../../shared/components/hyperlink';
import { withStaticContent } from '../../../ui/components/static-content';
import { memoizedFormatMetricValue } from '../../../metrics/metrics-helpers';

import './seo-links.less';

const defaultLinkSelector = state => state.siteConfig && state.siteConfig.wordCloud;

const seoLinks = props => {
    let { linkType = 'absolute', useDefaultLinks = false, className } = props;
    let links = props.links || [];

    const wordCloud = useSelector(defaultLinkSelector) || {};
    const { default: defaultLinks, forceDefault } = wordCloud;
    if (forceDefault) {
        links = defaultLinks;
    } else if (links.length === 0) {
        if (useDefaultLinks) {
            links = defaultLinks;
        }
    }

    return (
        <ul
            id="footerSEOLinks"
            className={`footer-seo-links-row page-width-container${className ? ' ' + className : ''}`}
        >
            {links &&
                links.map((link, index) => {
                    const className = index !== links.length - 1 ? '' : 'remove-pipe';
                    return (
                        <li key={index} className={className}>
                            <Link
                                aria-label={link.name}
                                linkType={linkType}
                                className="footer-seo-individual-link"
                                key={index}
                                to={link.url}
                                data-gtm-category="linkClick"
                                data-gtm-id="other"
                                data-gtm-value={memoizedFormatMetricValue(link.name)}
                            >
                                {link.name}
                            </Link>
                        </li>
                    );
                })}
        </ul>
    );
};

export default withStaticContent(seoLinks);
